import { render, staticRenderFns } from "./UserForgotPassword.vue?vue&type=template&id=39936274&"
import script from "./UserForgotPassword.vue?vue&type=script&lang=js&"
export * from "./UserForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports